export default __webpack_public_path__ + "static/media/flagSpecial2.41c667ca.svg";